let uri = 'http://localhost';

if (process.env.REACT_APP_ENV === 'staging') {
  uri = 'https://api.staging.usezapay.com.br';
}
else if (process.env.REACT_APP_ENV === 'production') {
  uri = 'https://api.usezapay.com.br';
}

export default uri;



// WEBPACK FOOTER //
// ./src/components/Pages/Unicef/constants.js